import React from 'react'
import { Container, Jumbotron, Button, Col, Row } from 'reactstrap'
import '../../Offer/offer.css'
import garden from './garden.png'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css' // This only needs to be imported once in your app
import tick from '../../images/tick.png'
var Translate = require('react-translate-component')

const images = [
  '/gardensGallery/1.jpg',
  '/gardensGallery/2.jpg',
  '/gardensGallery/3.jpg',
  '/gardensGallery/4.jpg',
  '/gardensGallery/5.jpg',
  '/gardensGallery/6.jpg'
]
const customStyles = {
  overlay: { zIndex: 1099 }
}

export default class Gardens1 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      photoIndex: 0,
      isOpen: false
    }
  }

  render () {
    const { photoIndex, isOpen } = this.state
    return (
      <Container id='servicesContentContainer'>
        <Row>
          <Col md='5' sm='12' className='contentDescription'>
            <div className='verticallyCentered'>
              <p className='contentTitle'>
                <Translate content='ogrody_zimowe' />
              </p>
              <p className='contentConstructionDescription'>
                <Translate content='proponujemy_naszym_klientom' />
              </p>
              <Row>
                <Col md='1' xs='1' sm='1' id='tickImg'>
                  <img src={tick} alt='tick' />
                </Col>
                <Col md='10' xs='9' sm='9'>
                  <p className='contentPoint'>
                    <Translate content='ogrody_zimowe_2' />
                  </p>
                </Col>
              </Row>
              <Row>
                <Col md='1' xs='1' sm='1' id='tickImg'>
                  <img src={tick} alt='tick' />
                </Col>
                <Col md='10' xs='9' sm='9'>
                  <p className='contentPoint'>
                    <Translate content='oranzerie' />
                  </p>
                </Col>
              </Row>
              <Row>
                <Col md='1' xs='1' sm='1' id='tickImg'>
                  <img src={tick} alt='tick' />
                </Col>
                <Col md='10' xs='9' sm='9'>
                  <p className='contentPoint'>
                    <Translate content='inne_zadaszenia' />
                  </p>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md='1' sm='12' xs='12'></Col>
          <Col md='6' sm='12' xs='12'>
            <div class='imageOfferContainer'>
              <img src={garden} alt='construction' />
              <button
                class='imageOfferBtn'
                onClick={() => this.setState({ isOpen: true })}
              >
                <Translate content='zobacz_galerie' />
              </button>
              {isOpen && (
                <Lightbox
                  reactModalStyle={customStyles}
                  mainSrc={process.env.PUBLIC_URL + images[photoIndex]}
                  nextSrc={
                    process.env.PUBLIC_URL +
                    images[(photoIndex + 1) % images.length]
                  }
                  prevSrc={
                    process.env.PUBLIC_URL +
                    images[(photoIndex + images.length - 1) % images.length]
                  }
                  onCloseRequest={() => this.setState({ isOpen: false })}
                  onMovePrevRequest={() =>
                    this.setState({
                      photoIndex:
                        (photoIndex + images.length - 1) % images.length
                    })
                  }
                  onMoveNextRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + 1) % images.length
                    })
                  }
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}
